import Base from './base'
import store from '@/store'
/**
 * 用户auth
 */
class Auth extends Base {
	/**
	 * @var resource 资源
	 */
	resource

	/**
	 * 初始化构造方法
	 *
	 * @param {Object} resource Socket消息
	 */
	constructor(resource) {
		super()

		this.resource = resource
	}

	handle() {
		switch (this.resource.code) {
			case "LoggedAnotherLocation":
			case "forceCheckout":
				store.dispatch('user/logout');
				this.$message.alert(this.resource.message, '系统提示', {
					confirmButtonText: '我知道了',
					type: 'warning',
					closeOnClickModal: false,
					showClose: false,
					center: true
				});
				break;
			default:
				return;
		}
	}
}

export default Auth
